export type MailingType = 'daily_activity_report';
export type MailingChannel = 'email' | 'telegram';

export interface MailingSubscription {
  type: MailingType;
  channel: MailingChannel;
  enabled: boolean;
}

export interface ClientMailingsResponse {
  hasTelegramConnected: boolean;
  subscriptions: MailingSubscription[];
}

export const MAILING_TYPE_LABELS: Record<MailingType, string> = {
  daily_activity_report: 'Щоденний звіт активності клієнта',
};

export const MAILING_TYPES: MailingType[] = ['daily_activity_report'];
